import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { NoMatch } from '../NoMatch';

export default function ResetPassword() {
  const [searchParams, _] = useSearchParams();
  const token = searchParams.get('token');

  const region = useMemo(() => {
    if (window.location.host === 'eu.smith.langchain.com') {
      return 'eu' as const;
    } else {
      return 'us' as const;
    }
  }, []);

  const euPrefix = region === 'eu' ? 'eu.' : '';
  if (!token) {
    return <NoMatch />;
  }

  const href = `https://${euPrefix}auth.langchain.com/auth/v1/verify?token=${token}&type=recovery&redirect_to=https://${euPrefix}smith.langchain.com/`;

  return (
    <div className="flex min-h-screen flex-col">
      <div className="flex flex-1 items-center justify-center">
        <div className="inline-flex w-[512px] flex-col items-center justify-center gap-6 rounded-xl border border-secondary bg-background px-6 py-[38px] shadow ">
          <div className="flex flex-col items-center justify-start gap-9 self-stretch">
            <div className="flex flex-col items-center justify-start gap-2 self-stretch">
              <div className="self-stretch text-center text-2xl font-semibold">
                Someone requested a password reset for your account.
              </div>
              <div className="text-center text-sm font-normal leading-tight text-stone-500 dark:text-stone-400">
                If that wasn't you, feel free to ignore this!
              </div>
            </div>
            <a
              href={href}
              className="inline-flex h-10 w-[361px] items-center justify-center gap-2 rounded-md border border-brand bg-brand-green-500 px-4 py-2.5 disabled:border-none disabled:bg-zinc-500 disabled:opacity-20 "
            >
              <div className="text-sm font-medium leading-tight text-white">
                Reset Password Here
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
